import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CircularIndeterminate from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const Onlineclass = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { courses } = useSelector((state) => state.courses);
  const { batches } = useSelector((state) => state.batches);



  // useEffect(() => {
  //   dispatch(actions.coursesGetData()); 
  //   dispatch(actions.batchesGetData());
  // }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      city: values.city,
      course_id: values.course_id,
      country_code:values.country_code,
      // batch_id: values.batch_id,
      // time_slot_id: values.time_slot_id,
      is_online_payment: values.is_online_payment,
      is_enquiry: values.is_enquiry,
    };
    dispatch(actions.postCourse(coursereg, setSubmitting));
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  //client_message: "",
                  //age: "",
                  country_code:"",
                  city: "Mumbai",
                  course_id: "",
                  // batch_id: "",
                  //   time_slot_id: "",
                  is_enquiry: "1",
                  is_online_payment: "0",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientname" className="label">
                          Enter Your Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname &&
                              formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientemail" className="label">
                          Enter Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail &&
                              formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="clientphone" className="label">
                          Enter Your Mobile:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Mobile"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone &&
                              formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="country_code" className="label">
                          Enter Your Country Code:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="country_code"
                            id="country_code"
                            placeholder="Enter Your Country Code"
                            className={
                              "form-control" +
                              (formProps.errors.country_code &&
                              formProps.touched.country_code
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="country_code"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="city" className="label">
                          Enter Your City:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Enter Your City"
                            className={
                              "form-control" +
                              (formProps.errors.city && formProps.touched.city
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col md={12} className="mt-2">
                        <Label htmlFor="course_id" className="label">
                          Select Course 
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="course_id"
                            id="course_id"
                            className={
                              "form-control" +
                              (formProps.errors.course_id &&
                              formProps.touched.course_id
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value="">
                              Select Course {" "}
                            </option>
                          </Field>
                          <ErrorMessage
                            name="course_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <div className="mt-3 mb-3 row">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? (
                            <CircularIndeterminate />
                          ) : (
                            "REGISTER"
                          )}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Onlineclass;
